<template>
    <q-page padding>
        <q-tabs color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab default slot="title" name="help" :label="$t('help')" icon="fal fa-question-square" />

            <q-tab-pane  name="help" class="q-px-md q-pb-xl q-mt-md">
                <div class="text-center logo-institutional" v-if="$route.name === 'login-help'">
                    <img class="cursor-pointer" :src="login_logo" @click="$router.push({ name: 'login' })" />
                </div>

                <q-alert
                    icon="fal fa-key"
                    color="tertiary"
                    :actions="[{ label: $t('recover_password'), handler: () => { this.$router.push({ name: 'recover-password' }) } }]"
                    class="q-mb-sm"
                    v-if="!access_token && clientName != 'academiapoptrade'"
                >
                    {{ $t('recover_password_helper') }}
                </q-alert>

                <div class="row gutter-sm">
                    <div class="col-xs-12 col-sm-6">
                        <q-input v-model="name" :float-label="$t('name')" :error="$v.name.$error" @input="$v.name.$touch" :disable="block_fields" />
                    </div>

                    <div class="col-xs-12 col-sm-6 ">
                        <q-input v-model="document" :float-label="`${current_client === 'academiacoral' ? $t('cpf_help_info') : $t('document')} ${register_fields.document_mandatory ? '*' : ''}`" :error="$v.document.$error" @input="$v.document.$touch" :disable="block_fields" />
                    </div>

                    <div class="col-12">
                        <q-input type="email" v-model="email" :float-label="$t('email')" :error="$v.email.$error" @input="$v.email.$touch" :disable="block_fields" />
                    </div>

                    <div class="col-12">
                        <q-input type="textarea" rows="5" v-model="message" :float-label="$t('message')" :error="$v.message.$error" @input="$v.message.$touch" />
                    </div>
                </div>

                <div class="col-12 q-mt-md row justify-end q-mt-lg">
                    <vue-recaptcha
                        class="q-mb-sm"
                        @verify="onVerifyRecaptcha"
                        @expired="onExpiredRecaptcha"
                        ref="recaptcha"
                        :loadRecaptchaScript="false"
                        :sitekey="getSiteKeyRecaptcha"
                    ></vue-recaptcha>
                </div>
                <div class="row gutter-sm justify-end">
                    <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                        <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="backButton()" />
                    </div>

                    <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                        <q-btn color="secondary" class="full-width" :label="$t('send')" icon="far fa-envelope" @click="sendEmail()" />
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email, requiredIf } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "login"] },

    data() {
        return {
            name: '',
            email: '',
            message: '',
            document: '',
            block_fields: false,
            current_client: '',
			recaptcha_token: null
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            login_logo: 'params/login_logo',
            name_store: 'common/full_name',
            email_store: 'common/email',
            document_store: 'common/user_document',
            clients: 'params/clients',
            register_fields: 'params/register_fields',
            id_user_client_selected: 'common/id_user_client_selected',
        }),

        clientName() {
            return process.env.PROJECT_FOLDER
        },

        getSiteKeyRecaptcha() {
			return process.env.GOOGLE_RECAPCHA_KEY
		},
    },

    methods: {
        getProjectName() {
            return process.env.PROJECT_NAME
        },

        sendEmail() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('full_name', this.name)
                fd.append('email', this.email)
                fd.append('message', this.message)
                fd.append('document', this.document)
                fd.append('recaptcha_token', this.recaptcha_token)

                this.$axios.post(`/admin_faq/help/`, fd, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('message_send_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })

                    this.$router.push({ name: 'login' })
                })
                .catch(e => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('message_send_error'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })

                    console.log(e)
                })
            }
        },

        onVerifyRecaptcha(token) {
			this.recaptcha_token = token
		},

		onExpiredRecaptcha() {
			this.recaptcha_token = null
		},

        backButton() {
            if (this.$route.name === 'help') {
                let obj_redirect = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj_redirect) {
                    if (obj_redirect.home_route) this.$router.replace({ name: obj_redirect.home_route })
                    else {
                        this.$router.replace({ name: 'courses' })
                    }
                }
                else {
                    this.$router.replace({ name: 'courses' })
                }
            }
            else if (this.$route.name === 'login-help') {
                this.$router.push({ name: 'login' })
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },
        getCurrentClient() {
            this.current_client = process.env.PROJECT_FOLDER
        }
    },

    created() {
        if (this.access_token) {
            this.block_fields = true
            this.name = this.name_store
            this.email = this.email_store
            this.document = this.document_store
        }
        this.getCurrentClient()
    },

    validations() {
        return {
            name: { required },
            email: { required, email },
            message: { required },
            document: {
                requiredIf: requiredIf(() => {
                    return this.register_fields.document_mandatory
                })
            },
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>
